export default __webpack_public_path__ + "9d385ae71a9b5835ac911afee048143d.png";